(function ($) {
  // When the menu changes, trigger skuSelect:
  $(document).on('change', 'select.js-sku-menu', function () {
    var skuId = $(this).val();
    var sku = prodcat.data.getSku(skuId);
    var skuBaseId;

    if (sku) {
      skuBaseId = sku.SKU_BASE_ID;
      $(this).closest('.js-product').trigger('product.skuSelect', [skuBaseId]);
    }
  });

  // Likewise, whenever skuSelect is fired on a product, update the menu:
  $('.js-product').on('product.skuSelect', function (event, skuBaseId) {
    $('select.js-sku-menu', this).val(skuBaseId);
    $('select.js-sku-menu.selectBox-attached', this).selectBox('value', skuBaseId);
  });

  // Update alt text for product images when skuSelect is fired
  $(document).on('product.skuSelect', '.js-product', function (event, skuBaseId) {
    var $product = $(this);
    var prod = $product ? prodcat.data.getProduct($product.data('product-id')) : null;
    var sku = prodcat.data.getSku(skuBaseId);
    var altText = prod?.PROD_RGN_NAME || '';
    altText += ' ' + (prod?.PROD_RGN_SUBHEADING || '');
    altText = altText.trim();
    if (sku?.SHADENAME) {
      altText += ', ' + sku.SHADENAME;
    }
    if (sku?.PRODUCT_SIZE) {
      altText += ', ' + sku.PRODUCT_SIZE;
    }
    $('.js-product-brief-image', $product).attr('alt', altText);
    $('.js-product-brief-image-alt', $product).attr('alt', altText);
  });

})(jQuery);
